import { DateTime } from 'luxon';
function parseDateTime(dateTimeLike, timezone) {
  let dateTime = null;
  if (typeof dateTimeLike === 'string') {
    dateTime = DateTime.fromISO(dateTimeLike);
  }
  if (typeof dateTimeLike === 'number') {
    dateTime = DateTime.fromMillis(dateTimeLike);
  }
  if (dateTimeLike instanceof Date) {
    dateTime = DateTime.fromJSDate(dateTimeLike);
  }
  if (dateTime && timezone) {
    return dateTime.setZone(timezone);
  }
  return dateTime;
}
export default {
  parseDateTime
};